exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line {\n  stroke-width: 2.5;\n  fill: none; }\n\n.line-group > path {\n  fill: none;\n  stroke-width: 4; }\n\n.text {\n  font-size: 12px; }\n\n.title-text {\n  font-size: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/MultiLineChart/multiLine.scss
// module id = 895
// module chunks = 0